import React from 'react';
import { Search } from 'lucide-react';
import Pagination from '@mui/material/Pagination';
import { StatusBadge } from '../../ui';
import { getPropImagePath, handleImageError } from '../../../utils/imageUtils';

const ListView = ({
  paginatedProps,
  totalPages,
  currentPage,
  onPageChange,
  addToCart,
  setSelectedProp
}) => {
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
        {paginatedProps.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="text-left p-3 text-xs font-medium text-gray-500 uppercase">Prop</th>
                  <th className="text-left p-3 text-xs font-medium text-gray-500 uppercase">Category</th>
                  <th className="text-left p-3 text-xs font-medium text-gray-500 uppercase">Owner</th>
                  <th className="text-left p-3 text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="text-left p-3 text-xs font-medium text-gray-500 uppercase">Distance</th>
                  <th className="text-left p-3 text-xs font-medium text-gray-500 uppercase">Actions</th>
                </tr>
              </thead>
              <tbody>
                {paginatedProps.map((prop, index) => (
                  <tr key={prop.id} className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`}>
                    <td className="p-3">
                      <div className="flex items-center gap-3">
                        <img 
                          src={getPropImagePath(prop)}
                          alt={prop.name}
                          className="w-12 h-12 object-cover rounded"
                          onError={(e) => handleImageError(e, prop.category)}
                        />
                        <div>
                          <div className="font-medium text-sm">{prop.name}</div>
                          <div className="text-xs text-gray-500">{prop.tags?.slice(0, 2).join(', ')}</div>
                        </div>
                      </div>
                    </td>
                    <td className="p-3 text-sm">{prop.category}</td>
                    <td className="p-3 text-sm">{prop.owner}</td>
                    <td className="p-3">
                      <StatusBadge status={prop.status} />
                    </td>
                    <td className="p-3 text-sm">{Math.round(prop.distance)} mi</td>
                    <td className="p-3">
                      <div className="flex gap-2">
                        {prop.status === 'available' && (
                          <button
                            onClick={() => addToCart(prop.id)}
                            className="bg-blue-600 text-white px-2 py-1 rounded text-xs hover:bg-blue-700"
                          >
                            Add
                          </button>
                        )}
                        <button
                          onClick={() => setSelectedProp(prop)}
                          className="bg-gray-600 text-white px-2 py-1 rounded text-xs hover:bg-gray-700"
                        >
                          View
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-12 text-gray-500">
            <Search className="h-16 w-16 mx-auto mb-4 opacity-50" />
            <p>No props found matching your criteria</p>
          </div>
        )}
      </div>
      {paginatedProps.length > 0 && (
        <Pagination 
          totalPages={totalPages} 
          currentPage={currentPage} 
          onPageChange={onPageChange} 
        />
      )}
    </div>
  );
};

export default ListView;